import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { db } from '../firebase';
import { setUserChatList } from '../store/NewChatSlice';

export const useNewUserChatListListener = () => {
  const { user } = useSelector((state) => state.login);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user.role === undefined) return;
    if (user.role === 'user') {
      const dbRef = doc(db, 'userChats', user._id);
      const unsubscribe = onSnapshot(dbRef, (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          dispatch(setUserChatList(data));
        }
      });
      return () => unsubscribe();
    }
  }, []);
};
